import {
    globalAxios,
    backendVersion,
    managerInstance,
    merchantInstance,
    axiosPath,
} from "@/axios-path.js";
import axios from "axios";

export default {
    namespaced: true,
    state: {
        bankListData: [],
        setBankById: { bank_manager_bank: {} },
        setStatus: [],
        setStatusBankApprove: [],
        setstatusapprove: [],
        getCountApprove: ""
    },
    mutations: {
        getBanklist(state, data) {
            state.bankListData = data;
            state.setStatus = state.bankListData.filter(word => word.bank_manager_status === 2);
        },
        getBanklistApprove(state, data) {
            state.setstatusapprove = data;
            state.setStatusBankApprove = state.setstatusapprove.filter(word => word.bank_manager_status === 1);
        },
        setBankById(state, data) {
            state.setBankById = data;
        },
        GetCountApproveBank(state, data) {
            state.getCountApprove = data
        }
    },

    actions: {

        async fetchBanklist({ commit }, config) {
            let url = backendVersion.version + "/partner/get_list_bank_manager_backoffice";
            return managerInstance
                .get(url, { params: config })
                .then((res) => {
                    if (res.msg == false) return false;
                    commit("getBanklist", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return [];
                });
        },
        async fetchBanklistApprove({ commit }, config) {
            let url = backendVersion.version + "/partner/get_list_bank_manager_backoffice";
            return managerInstance
                .get(url, { params: config })
                .then((res) => {
                    if (res.msg == false) return false;
                    commit("getBanklistApprove", res.data);
                    return res.data;
                })
                .catch((err) => {
                    return [];
                });
        },
        async fetchBankByid({ commit }, item) {
            let url = `${backendVersion.version
                }/partner/get_bank_manager_detail_backoffice/${item}`;
            return managerInstance
                .get(url)
                .then((res) => {
                    if (res.msg == false) return false;
                    commit("setBankById", res.data);
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async GetCountApproveBank({ commit }, config) {
            let url = `${backendVersion.version
                }/partner/get_count_approve_bank`;
            return managerInstance
                .get(url, { params: config })
                .then((res) => {
                    if (res.msg == false) return false;
                    commit("GetCountApproveBank", res.data);
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async ApproveBankManager({ commit }, id) {
            let url = `${backendVersion.version
                }/partner/approve_bank_manager/${id}`;
            return managerInstance
                .post(url)
                .then((res) => {
                    if (res.msg == false) return false;
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },

        async deleteBankManagerBackoffice({ commit, dispatch }, item) {
            let url = `${backendVersion.version
                }/partner/delete_bank_manager_backoffice/${item}`;
            return managerInstance
                .delete(url)
                .then((res) => {
                    if (res.msg == false) return false;
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
        async RejectBankManager({ commit, dispatch }, { payload }) {
            let url = backendVersion.version + "/partner/reject_bank_manager";
            const remark = {
                bank_manager_id: payload.id,
                remark: payload.remark,
            }
            return managerInstance
                .delete(url, {
                    data: remark,
                })
                .then((res) => {
                    if (res.msg == false) return false;
                    return res.data;
                })
                .catch(() => {
                    return false;
                });
        },
    },
    getters: {},
};
